export const mockAPIPath = {
    ACTIVITY_LOG : "./data/activityLog.json",
};

export const serverAPIPath = {
    ACTIVITY_LOG : "/activity-logs",
};